import React from 'react'
import { Route } from 'react-router'

const Routes = (
  <Route path="/internal/drift-admin-panel" component={() => window.location.replace('/settings2/deal-admin')}>
    <Route path="deal-admin" component={() => window.location.replace('/settings2/deal-admin')}/>
  </Route>
)

export default Routes



// WEBPACK FOOTER //
// ./src/scripts/app/routes/DriftAdminPanelRoutes.js